import { BaseStatusDto } from '../baseStatusDto';

export class AuditFormStatusDto extends BaseStatusDto {}
